import { HugeiconsIcon } from "@hugeicons/react";
import {
  Cancel01Icon,
  ComputerIcon,
  SmartPhone01Icon,
  RefreshIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { ViewMode } from "./types";
import { Tabs } from "shared/components/BaseTabs";

export const Toolbar = ({
  viewMode,
  onViewModeChange,
  onRestart,
  onClose
}: {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  onRestart: () => void;
  onClose: () => void;
}) => (
  <header className="h-14 shrink-0 flex items-center justify-between px-6 border-b border-alpha-80">
    <Button
      HugeIcon={Cancel01Icon}
      size={ButtonSize.SM}
      variant={ButtonVariant.BASE}
      onClick={onClose}
    >
      Close
    </Button>

    <Tabs
      size="sm"
      onChange={onViewModeChange}
      tabStyle="ghost"
      active={viewMode}
      tabs={[
        {
          label: "Desktop",
          value: "desktop",
          leftElement: {
            type: "icon" as const,
            component: ComputerIcon
          }
        },
        {
          label: "Mobile",
          value: "mobile",
          leftElement: {
            type: "icon" as const,
            component: SmartPhone01Icon
          }
        }
      ]}
    />

    <button
      type="button"
      onClick={onRestart}
      // Designer asked for no hover state. As per design
      className="flex items-center gap-1.5 text-sm font-medium text-content-1000 transition-colors"
    >
      <HugeiconsIcon icon={RefreshIcon} size={16} strokeWidth={1.5} />
      Restart
    </button>
  </header>
);
